import { render, staticRenderFns } from "./ProductDetailWizard.vue?vue&type=template&id=1f0cbc98&scoped=true"
import script from "./ProductDetailWizard.vue?vue&type=script&lang=js"
export * from "./ProductDetailWizard.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailWizard.vue?vue&type=style&index=0&id=1f0cbc98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0cbc98",
  null
  
)

export default component.exports